module.exports = __webpack_public_path__ + "static/media/lucieGuibault.a8ca5b1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/lucieGuibault.jpg
// module id = 1682
// module chunks = 1